export const ATTRIBUTE_ROUTES = {
	ATTRIBUTES: 'attributes' as const,
	ATTRIBUTE_DETAILS: 'attributeDetails' as const,
	ADD_ATTRIBUTE: 'addAttribute' as const,
	EDIT_ATTRIBUTE: 'editAttribute' as const,
};

export type AttributeRouteType = (typeof ATTRIBUTE_ROUTES)[keyof typeof ATTRIBUTE_ROUTES];

export interface AttributeRouteInfo {
	route: AttributeRouteType;
	attributeId?: string;
}
